module.exports = {
  application_name: `dashboard`,
  application_title : 'Dashboard',
  support_email: 'support@campbellcloud.io',
  login_url: 'https://login.campbellcloud.io',
  tour_url: 'https://help.campbellsci.com/cloud-en/home.htm'      // fill in once we know URL of specific feature  
};
